import { MutableRefObject } from 'react'
import { AlmanacFileSummary, ArticleFlat } from '../../types'

export enum ReviewType {
  FEEDBACK = 'feedback',
  APPROVAL = 'approval',
  SUGGESTIONS = 'suggestions',
  READ_RECEIPTS = 'readReceipts',
}

export const REVIEW_TYPE_PARAM_KEY = 'reviewType'

export const maybeReviewType = (x: string | null) =>
  x && Object.values(ReviewType).includes(x as ReviewType) ? (x as ReviewType) : null

export enum ReviewPrivacy {
  PUBLIC = 'public',
  PRIVATE = 'private',
}

export enum ReviewerRole {
  APPROVER = 'approver',
  REVIEWER = 'reviewer',
  VIEWER = 'viewer',
}

export interface ModalPortals {
  header: MutableRefObject<HTMLDivElement | null>
  footer: MutableRefObject<HTMLDivElement | null>
}

export interface ExternalLinkReviewAsset {
  title: string
  link: string
  icon: string
}

export enum ReviewAssetType {
  Article = 'Article',
  Design = 'Design',
  ExternalLink = 'ExternalLink',
}

export type ReviewAsset = ArticleFlat | AlmanacFileSummary | ExternalLinkReviewAsset
